import { Typography as MuiTypography, Link as MuiLink } from "@mui/material";
import { Trans } from "react-i18next";
import Export from "app/shared/UI/Export";
import { PepOnStudy, URLs } from "app/shared/constants";
import { headerStyles, multiLineCell } from "app/shared/UI/sharedStyles";

export const defaultTableColumnHeaders = (t) => [
  {
    field: "irbNumber",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.irb" />
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 100,
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        <MuiLink
          href={`${window.location.origin}/outreach/${row.studyId}/conduct`}
          target="_blank"
          rel="noopener noreferrer"
          replace
        >
          {row.irbNumber}
        </MuiLink>
      </MuiTypography>
    ),
  },
  {
    field: "waveName",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.fileName" />
      </MuiTypography>
    ),
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        <Export
          displayName={row.waveName}
          // TODO: use wavename_<filename>
          downloadName={row.waveName + ".csv"}
          exportURL={`${URLs.GET_OUTREACH_URL_BASE}/${row.outreachId}/file`}
        />
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 250,
  },
  {
    field: "channel",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.outreachChannel" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    flex: 1,
    minWidth: 150,
  },
  {
    field: "status",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.outreachStatus" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    flex: 1,
    minWidth: 150,
  },
  {
    field: "conductedDate",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.outreachDate" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {new Date(value).toLocaleString()}
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 200,
  },
  {
    field: "failureReason",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.failureReason" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    flex: 1,
    minWidth: 200,
    sortable: false,
  },
  {
    field: "responseStatus",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.responseStatus" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {t(`ProspectDetailsOutreachHistory.${value}`)}
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 200,
  },
  {
    field: "pepOnStudy",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsOutreachHistory.pepOnStudy" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {value ? PepOnStudy.YES : PepOnStudy.NO}
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 100,
  },
];
